import React, { forwardRef, useImperativeHandle, useRef } from 'react';
import { TagSelector } from './TagSelector';

interface TagManagementProps {
  tags: string[];
  onChange: (tags: string[]) => void;
  readOnly?: boolean;
  suggestions?: string[];
  className?: string;
}

// Define ref type for the TagManagement component
export interface TagManagementRef {
  processPendingTags: () => Promise<void>;
}

export const TagManagement = forwardRef<TagManagementRef, TagManagementProps>(({
  tags = [],
  onChange,
  readOnly = false,
  suggestions = [],
  className = ''
}, ref) => {
  // Reference to the TagSelector component
  const tagSelectorRef = useRef<React.ElementRef<typeof TagSelector>>(null);
  
  // Expose methods to parent components
  useImperativeHandle(ref, () => ({
    processPendingTags: async () => {
      if (tagSelectorRef.current) {
        await tagSelectorRef.current.processPendingTags();
      }
    }
  }));
  
  return (
    <TagSelector
      ref={tagSelectorRef}
      selectedTags={tags}
      onChange={onChange}
      readOnly={readOnly}
      className={className}
    />
  );
});

export default TagManagement;